/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import InlineResponse20012StartDateJoin from './InlineResponse20012StartDateJoin';

/**
 * The InlineResponse20012EventCalendars model module.
 * @module model/InlineResponse20012EventCalendars
 * @version 1.0.0
 */
class InlineResponse20012EventCalendars {
    /**
     * Constructs a new <code>InlineResponse20012EventCalendars</code>.
     * @alias module:model/InlineResponse20012EventCalendars
     */
    constructor() { 
        
        InlineResponse20012EventCalendars.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineResponse20012EventCalendars</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineResponse20012EventCalendars} obj Optional instance to populate.
     * @return {module:model/InlineResponse20012EventCalendars} The populated <code>InlineResponse20012EventCalendars</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineResponse20012EventCalendars();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('start_date')) {
                obj['start_date'] = InlineResponse20012StartDateJoin.constructFromObject(data['start_date']);
            }
            if (data.hasOwnProperty('end_date')) {
                obj['end_date'] = InlineResponse20012StartDateJoin.constructFromObject(data['end_date']);
            }
            if (data.hasOwnProperty('formatted_start_date')) {
                obj['formatted_start_date'] = ApiClient.convertToType(data['formatted_start_date'], 'String');
            }
            if (data.hasOwnProperty('formatted_end_date')) {
                obj['formatted_end_date'] = ApiClient.convertToType(data['formatted_end_date'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
InlineResponse20012EventCalendars.prototype['id'] = undefined;

/**
 * @member {module:model/InlineResponse20012StartDateJoin} start_date
 */
InlineResponse20012EventCalendars.prototype['start_date'] = undefined;

/**
 * @member {module:model/InlineResponse20012StartDateJoin} end_date
 */
InlineResponse20012EventCalendars.prototype['end_date'] = undefined;

/**
 * @member {String} formatted_start_date
 */
InlineResponse20012EventCalendars.prototype['formatted_start_date'] = undefined;

/**
 * @member {String} formatted_end_date
 */
InlineResponse20012EventCalendars.prototype['formatted_end_date'] = undefined;






export default InlineResponse20012EventCalendars;

